import { Modal, Form, Input, Select, Row, Col, Card } from "antd";
import { useEffect, useMemo, useState } from "react";
import { ShopOutlined, EnvironmentOutlined } from "@ant-design/icons";
import { cardHeaderStyle, cardStyle, CardTitle, filterOption } from "../ingresosPOCardStyles";

const { Option } = Select;

export default function BodegaForm({
  open,
  onCancel,
  onSubmit,
  initialValues,
  organizaciones = [],
  departamentos = [],
  municipios = [],
  responsables = []
}) {

  const [form] = Form.useForm();
  const [departamentoSeleccionado, setDepartamentoSeleccionado] = useState(null);

  useEffect(() => {
    if (initialValues) {
      setDepartamentoSeleccionado(initialValues.oid_departamento);
      form.setFieldsValue({
        oid_organizacion: initialValues.oid_organizacion,
        sigla: initialValues.sigla,
        oid_departamento: initialValues.oid_departamento,
        oid_municipio: initialValues.oid_municipio,
        responsable_login: initialValues.responsable_login
      });
    } else {
      setDepartamentoSeleccionado(null);
      form.resetFields();
    }
  }, [initialValues, open]);

  const municipiosFiltrados = useMemo(() => {
    if (!departamentoSeleccionado) return [];
    return municipios.filter(
      (m) => Number(m.oid_depto) === Number(departamentoSeleccionado)
    );
  }, [municipios, departamentoSeleccionado]);

  const handleDepartamentoChange = (value) => {
    setDepartamentoSeleccionado(value);
    form.setFieldsValue({ oid_municipio: undefined });
  };

  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        onSubmit(values);
        form.resetFields();
      });
  };

  return (
    <Modal
      open={open}
      title={initialValues ? "Editar bodega" : "Nueva bodega"}
      okText="Guardar"
      cancelText="Cancelar"
      onCancel={onCancel}
      onOk={handleOk}
      width={640}
      destroyOnClose
    >
      <Form form={form} layout="vertical" component={false}>

        <Card
          style={cardStyle}
          styles={{ header: cardHeaderStyle, body: { padding: 20 } }}
          title={<CardTitle icon={<ShopOutlined />}>Organización</CardTitle>}
        >
          <Row gutter={[20, 8]}>
            <Col span={16}>
              <Form.Item
                label="Organización"
                name="oid_organizacion"
                rules={[{ required: true, message: "Seleccione la organización" }]}
              >
                <Select
                  size="large"
                  showSearch
                  allowClear
                  placeholder="Seleccione la organización"
                  filterOption={filterOption}
                >
                  {organizaciones.map((o) => (
                    <Option key={o.oid} value={o.oid}>
                      {o.organizacion} {o.sigla ? `(${o.sigla})` : ""}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label="Sigla de la bodega"
                name="sigla"
                rules={[{ required: true, message: "Ingrese la sigla" }]}
              >
                <Input size="large" placeholder="Ej: BOD-01" />
              </Form.Item>
            </Col>
          </Row>
        </Card>

        <Card
          style={{ ...cardStyle, marginBottom: 0 }}
          styles={{ header: cardHeaderStyle, body: { padding: 20 } }}
          title={<CardTitle icon={<EnvironmentOutlined />}>Ubicación y responsable</CardTitle>}
        >
          <Row gutter={[20, 8]}>
            <Col span={12}>
              <Form.Item
                label="Departamento"
                name="oid_departamento"
                rules={[{ required: true, message: "Seleccione el departamento" }]}
              >
                <Select
                  size="large"
                  showSearch
                  allowClear
                  placeholder="Seleccione el departamento"
                  filterOption={filterOption}
                  onChange={handleDepartamentoChange}
                >
                  {departamentos.map((d) => (
                    <Option key={d.oid} value={d.oid}>
                      {d.departamento}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Municipio"
                name="oid_municipio"
                rules={[{ required: true, message: "Seleccione el municipio" }]}
              >
                <Select
                  size="large"
                  showSearch
                  allowClear
                  disabled={!departamentoSeleccionado}
                  placeholder={
                    departamentoSeleccionado
                      ? "Seleccione el municipio"
                      : "Primero seleccione un departamento"
                  }
                  filterOption={filterOption}
                >
                  {municipiosFiltrados.map((m) => (
                    <Option key={m.oid} value={m.oid}>
                      {m.municipio}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                label="Responsable"
                name="responsable_login"
                rules={[{ required: true, message: "Seleccione el responsable" }]}
              >
                <Select
                  size="large"
                  showSearch
                  allowClear
                  placeholder="Seleccione el responsable"
                  filterOption={filterOption}
                >
                  {responsables.map((r) => (
                    <Option key={r.login} value={r.login}>
                      {r.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
        </Card>
      </Form>
    </Modal>
  );
}
